import { createAction, props } from '@ngrx/store';
import { DataleanUser } from '../../models/base-user.interface';

export const authInitialized = createAction('[User] Authentication initialized');
export const fetchUserData = createAction('[User] Fetch user data', props<{ uuid: string }>());
export const setUserData = createAction('[User] Set user data', props<{ userData: DataleanUser }>());
